import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

type AddressState = CommonTableState;

const initialState: AddressState = {
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "city", desc: false }],
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        columnVisibility: {
            main: false,
            created: false,
            creator: false,
            addressFull: false,
            cityDistrict: false,
            cityPart: false,
            postalCode: false,
            streetNumber: false,
            township: false,
        },
        columnOrder: [
            "company.id",
            "person.id",
            "addressFull",
            "main",
            "street",
            "houseNumber",
            "streetNumber",
            "city",
            "cityDistrict",
            "cityPart",
            "postalCode",
            "township",
            "state.name",
            "source",
            "creator",
            "created",
            "mrt-row-actions",
        ],
        density: "compact",
    },
};

export const addressSlice = createSlice({
    name: "address",
    initialState: initialState,
    reducers: {
        updateAddressTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

// Action creators are generated for each case reducer function
export const {updateAddressTableState} = addressSlice.actions;

export default addressSlice.reducer;
